import { Meta } from '~/components/common/meta'
import { PageLayout } from '~/components/layout/page'
import { Policy } from '~/components/sections/legal/policy'

const Privacy = () => {
  return (
    <PageLayout>
      <Meta title="Privacy Policy | Ride the Bus" />
      <Policy />
    </PageLayout>
  )
}

export default Privacy
